import React, { createContext, useEffect, useState } from "react";
import Posgrados from "./posgrados";
import DataCampus from "./campus";
import DataEscuelas from "./escuelas";
import DataNivel from "./nivelProgama";


import Programa from "./list";
import FiltroPrograma from "./filtro_programa";
import ProgramaCurso from "./ProgramaCurso";
//import CardCampus from "./card_campus";


export const GlobalStateContext = createContext();

function App() {
  //const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$anahuacs-leadership/.test(string);
  const [dataOriginal] = useState(Posgrados);
  const [item, setitem] = useState(Posgrados);
  const [idProgram, setidProgram] = useState(0);
  const [visibleCount, setVisibleCount] = useState(20);


  const [idCampus, setidCampus] = useState('all');
  const [idNivel, setidNivel] = useState('all');
  const [idFacultad, setidFacultad] = useState('all');

  const [optionProgram, setoptionProgram] = useState(DataNivel);
  const [optionFacultad, setoptionFacultad] = useState(DataEscuelas);
  const [optionCampus, setoptionCampus] = useState(DataCampus);
  const [refreshKey, setRefreshKey] = useState(0);
  //idCampus, idNivel, idFacultad
  const nivelMap = {
    maestrias: "3",
    doctorados: "1",
    especialidades: "2",
  };
  useEffect(() => {
    const applyFilterFromURL = () => {
      const path = window.location.pathname.toLowerCase();
      const segments = path.split("/").filter(Boolean);

      const index = segments.indexOf("posgrados");

      if (index !== -1 && segments[index + 1]) {
        const slug = segments[index + 1];

        if (nivelMap[slug]) {
          setidNivel(nivelMap[slug]);
          return;
        }
      }

      setidNivel("all");
    };

    applyFilterFromURL();

    window.addEventListener("popstate", applyFilterFromURL);

    return () => {
      window.removeEventListener("popstate", applyFilterFromURL);
    };
  }, []);

  useEffect(() => {
    if (!Array.isArray(dataOriginal)) return;

    const dataFiltrada = dataOriginal.filter((val) => {
      const matchCampus =
        idCampus === "all" ||
        val.campus_pro?.some(
          (campus) =>
            campus.id_escuelas?.toString() === idCampus?.toString()
        );

      const matchNivel =
        idNivel === "all" ||
        val.id_nivel?.toString() === idNivel?.toString();

      const matchFacultad =
        idFacultad === "all" ||
        val.id_facultad?.toString() === idFacultad?.toString();

      return matchCampus && matchNivel && matchFacultad;
    });

    setitem(dataFiltrada);
    setidProgram(0);
    setVisibleCount(20);

  }, [idCampus, idNivel, idFacultad, dataOriginal, refreshKey]);
  return (
    <GlobalStateContext.Provider
      value={{
        item,
        setitem,
        idProgram,
        setidProgram,
        idCampus,
        setidCampus,
        idNivel,
        setidNivel,
        idFacultad,
        setidFacultad,
        visibleCount,
        setVisibleCount,
        optionProgram,
        setoptionProgram,
        optionFacultad,
        setoptionFacultad,
        optionCampus,
        setoptionCampus,
        refreshKey,
        setRefreshKey

      }}
    >

      <div className="App">

        <FiltroPrograma />

        <div className="container">
          {idProgram !== 0 ? (
            <ProgramaCurso />
          ) : (
            <Programa />
          )}
        </div>
      </div>
    </GlobalStateContext.Provider>

  );
}

export default App;
